 
<!--<router-outlet></router-outlet>-->
  <app-newmenu *ngIf="mostrarMenu"></app-newmenu>  
  <app-iconos-login></app-iconos-login>
<!--<router-outlet></router-outlet>-->